import React from "react";

export default function Testionials() {
  return (
    <div>
      <div class="testimonial_wrapper float_left">
        <div class="investment_overlay"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark">
                <h4>testimonial</h4>
                <h3>what people says</h3>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="testimonial_slider_wrapper">
                <div class="owl-carousel owl-theme">
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper dark_top_testimonial">
                      <div class="ts_client_cont_wrapper">
                        <p>
                          <q>
                            Treasure growth investment has helped me in my
                            finance since i joined the company its been a
                            wonderful experience
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper">
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts1.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                        <div class="ts_client_social_wrapper">
                          <p>
                            - by bjanrne bayi
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper">
                      <div class="ts_client_cont_wrapper dark_testimonial_wrapper">
                        <p>
                          <q>
                            It’s truly the best as i can attest to the my
                            financial growth since i joined the company
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper p2">
                        <div class="ts_client_social_wrapper right_social_medaia">
                          <p>
                            - by Katrina
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts2.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper dark_top_testimonial">
                      <div class="ts_client_cont_wrapper">
                        <p>
                          <q>
                            Treasure growth investment is the best platform to
                            join if you want to gain financial freedom they have
                            amazing ROI
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper">
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts1.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                        <div class="ts_client_social_wrapper">
                          <p>
                            - by Philip Water
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper">
                      <div class="ts_client_cont_wrapper dark_testimonial_wrapper">
                        <p>
                          <q>
                            I used to feel too young to start setting money
                            aside, with treasuregrowthinvestment I have realized
                            it is never too early to get started with your
                            savings.
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper p2">
                        <div class="ts_client_social_wrapper right_social_medaia">
                          <p>
                            - by Mellon Prem
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts2.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper dark_top_testimonial">
                      <div class="ts_client_cont_wrapper">
                        <p>
                          <q>
                            treasuregrowthinvestment is my coping mechanism to
                            build up for an independent life.
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper">
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts1.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                        <div class="ts_client_social_wrapper">
                          <p>
                            - by Merry Jain
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="testimonial_slide_main_wrapper">
                      <div class="ts_client_cont_wrapper dark_testimonial_wrapper">
                        <p>
                          <q>
                            Treasure growth investment has yield me much
                            profit,thanks to the great team please keep up the
                            good service.
                          </q>
                        </p>
                      </div>
                      <div class="ts_img_social_wrapper p2">
                        <div class="ts_client_social_wrapper right_social_medaia">
                          <p>
                            - by larry gold.
                            <br /> <span>(investor, gold)</span>
                          </p>
                        </div>
                        <div class="ts_client_img_wrapper">
                          <img
                            src="images/ts2.png"
                            class="img-responsive"
                            alt="client_img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
